export default __webpack_public_path__ + "static/ezrzKioi-07f4a8eb52d605b03120a1cb1c2f840a.svg";